"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateApproveFinalClaim = exports.approveFinalClaimSchema = void 0;
var constants_1 = require("@hobt/constants");
var schema_validator_1 = require("@hobt/schema-validator");
var approval_1 = require("./approval");
exports.approveFinalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['approverReview'],
    properties: {
        attachments: {
            type: ['array', 'null'],
            items: approval_1.approvalAttachmentSchema,
            errorMessage: 'Should be an array of ApprovalAttachments or null',
        },
        approverReview: approval_1.approverReviewSchema,
    },
    allOf: [
        {
            if: {
                properties: {
                    approverReview: {
                        type: 'object',
                        required: ['approvalOnBehalfOfOtherFlag'],
                        properties: {
                            approvalOnBehalfOfOtherFlag: {
                                // if flag is true, then attachments need to be non null
                                enum: [true],
                            },
                        },
                    },
                },
            },
            then: {
                required: ['attachments'],
                properties: {
                    attachments: {
                        type: 'array',
                        items: approval_1.approvalAttachmentSchema,
                        minItems: 1,
                        errorMessage: 'Should be an array of ApprovalAttachments with at least 1 item',
                    },
                },
            },
            errorMessage: constants_1.HbtValidationErrorCodes.HBT_ERR_APPROVE_BEHALF_OF_OTHER_PERSON_DOCUMENTID_REQUIRED.code + ": attachments is required if approverReview.approvalOnBehalfOfOtherFlag is true",
        },
    ],
};
exports.validateApproveFinalClaim = function (data) {
    var approveFinalClaimValidator = new schema_validator_1.SchemaValidator(exports.approveFinalClaimSchema, true, false, true, true);
    return approveFinalClaimValidator.validate(data);
};
